import { useUser } from '../pages/orders/hooks/useUser';
import auth from './auth/auth';
import crud from './crud/crud';
import file from './files/file';
import order from './order/order';
import plan from './plan/plan';
import transaction from './transaction/transaction';
import category from './category/category';

export const apiV2 = {
  host: process.env.REACT_APP_API_URL,
  getToken: () => {
    const { getUser } = useUser();
    return getUser()?.RestfulToken;
  },
  auth: auth,
  crud: crud,
  file: file,
  order: order,
  category: category,
  plan: plan,
  transaction: transaction
};
